/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import scalefieldLogo from '../../assets/images/scalefield_logo_white.svg';
import { BasicRoutes } from '../../constants/basicRoutes';
import { Namespaces } from '../../i18n';
import { NotFoundLayout } from '../../layouts/NotFoundLayout/NotFoundLayout';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
import { useMaintenanceStyles } from './styles';

export const MaintenancePage = memo(() => {
  const classes = useMaintenanceStyles();
  const { t } = useTranslation(Namespaces.Navigation);

  const handleGoHome = () => location.replace(BasicRoutes.HOME);

  useDocumentTitle(t('maintenance.title'));

  return (
    <NotFoundLayout>
      <Box display="flex" flexDirection="column" gap={8} alignItems="center">
        <Box className={classes.logoContainer} onClick={handleGoHome}>
          <img src={scalefieldLogo} alt="Logo" className={classes.logoImage} />
        </Box>
        <Typography variant="h1" style={{ color: '#fff' }}>
          {t('maintenance.subtitle')}
        </Typography>
        <Box className={classes.descriptionText}>
          {t('maintenance.description')}
          <br />
          {t('maintenance.contact_line')}
        </Box>
      </Box>
    </NotFoundLayout>
  );
});
